import React from 'react';

export default function useWindowOpen(url: string) {
  const handleOpenWindow = React.useCallback(() => {
    if (!window || !url) {
      return;
    }
    window.open(url, '_blank', 'noreferrer');
  }, [url]);

  return handleOpenWindow;
}
